import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../mdx/blogs';
import './Allblogs.css';

const formatDate = (date) => new Date(date).toLocaleDateString(undefined, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

const readTime = (post) => {
  const words = `${post.description || ''}`.trim().split(/\s+/).filter(Boolean).length;
  return `${Math.max(1, Math.round(words / 200))} min read`;
};

const Allblogs = () => (
  <section className="blogs-section">
    <div className="blogs-container">
      <div className="blogs-header">
        <h2 className="blogs-title">Latest Blog Posts</h2>
        <p className="blogs-subtitle">Insights, tips and industry trends from our experts</p>
      </div>
      <div className="blogs-grid">
        {blogPosts.length === 0 ? (
          <div className="blogs-empty"><h3>No blog posts yet</h3><p>Check back later for new content</p></div>
        ) : blogPosts.map((post) => (
          <article key={post.slug} className="blog-card">
            <div className="blog-card-inner">
              <div className="blog-card-media">
                <div className="blog-image-container"><img src={post.featuredImage} alt={post.title} loading="lazy" className="blog-card-image" /><div className="image-overlay"></div></div>
                <div className="blog-card-category">{post.category}</div>
              </div>
              <div className="blog-card-content">
                <div className="blog-card-meta"><span className="blog-card-date">{formatDate(post.publishedAt)}</span><span className="blog-card-read-time">{readTime(post)}</span></div>
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-excerpt">{post.description}</p>
                <Link to={`/blog/${post.slug}`} className="blog-card-link">Read more<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Allblogs;
